import type { AuditLog } from '@/types/audit-log.type';

export const MAX_MESSAGE_FIELDS = 3;
export const PAYLOAD_KEY = 'payload';

export const getPayload = (log: AuditLog) => log.message?.[PAYLOAD_KEY];

export const getMessageEntries = (log: AuditLog) => {
  return Object.entries(log.message ?? {}).filter(([key]) => key !== PAYLOAD_KEY);
};

export const humanizeLabel = (value: string) => {
  return value.replace(/_/g, ' ').replace(/\b\w/g, character => character.toUpperCase());
};

export const formatMessageValue = (value: unknown) => {
  if (value == null) {
    return 'n/a';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  return String(value);
};

export const getEventBadgeProps = (type: string) => {
  const normalizedType = type.toLowerCase();

  if (normalizedType === 'error') {
    return { variant: 'fail' as const };
  }

  if (normalizedType === 'warning') {
    return { variant: 'pending' as const };
  }

  return {
    variant: 'outline' as const,
    className:
      'border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300',
  };
};
